'use strict';

var sha3 = require('js-sha3');

var convert = require('./convert.js');

function keccak256(data) {
    data = convert.arrayify(data);
    return '0x' + sha3.keccak_256(data);
}

module.exports = keccak256;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ethers/utils/keccak256.js
// module id = 297
// module chunks = 0